import { AppRouter } from "./app-router/AppRouter";
import { ToastContainer } from "react-toastify";
import './index.css';
import theme from './theme';
import { ThemeProvider} from '@mui/material/styles';
import {useAuth} from "./hooks/useAuth"
import './styles.css';

const App = () => {
  const {  isLoggedIn } = useAuth();

  return (
    <ThemeProvider theme={theme}>
      <main className='container'>
         <AppRouter isLoggedIn={isLoggedIn}/>
      <ToastContainer />
      </main>
      </ThemeProvider>
  );
};

export default App;
